
import commonAxios from '../utils/common';
import axios from '../utils/auth';

const register = (inputs) => {
    inputs = inputs.inputs;
    return commonAxios.post("/signup", inputs);
};

const login = (inputs) => {
    inputs = inputs.inputs;
    return commonAxios.post("/signin", inputs)
        .then((response) => {
            if (response.data.data.token) {
                localStorage.setItem("userToken", response.data.data.token);
            }

            return response.data.data;
        });
};

const profileUpdate = (inputs) => {
    inputs = inputs.inputs;
    return axios().post("profile-update", inputs);
}

const getprofile = () => {
    return axios().get('profile').then((res) => {
        return res;
    }).catch((e) => {
        if (e.code == "ERR_BAD_REQUEST") {
            localStorage.removeItem("userToken");
        }
    });
}

const getMembers = (pageNumber) => {

    return axios().get("members?page=" + pageNumber.page + "&sort_by=" + pageNumber.sort_by + "&sort_type=" + pageNumber.sort_type + "&search=" + pageNumber.search + "&search_type=" + pageNumber.search_type);
}

const getMemberDetails = (member_id) => {
    return axios().get("member?member_id=" + member_id);
}
const logout = () => {
    localStorage.removeItem("userToken");
};

const authService = {
    register,
    login,
    logout,
    getprofile,
    profileUpdate,
    getMembers,
    getMemberDetails
};

export default authService;
